var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"oo-viewer"},[(_vm.loading)?_c('div',{staticClass:"oo-loading"},[_vm._v("正在加载 OnlyOffice 预览...")]):(_vm.error)?_c('div',{staticClass:"oo-error"},[_vm._v(_vm._s(_vm.error))]):_vm._e(),_c('div',{staticClass:"oo-editor",attrs:{"id":_vm.editorId}})])
}
var staticRenderFns = []

export { render, staticRenderFns }